import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import API_URL from "../../api/API";

const BusinessSmartTemplateStep1 = () => {
  const { business, dispatch } = useBusinessAuthContext();
  const navigate = useNavigate();

  const [serviceId, setServiceId] = useState("");
  const [services, setServices] = useState([]);
  const [loadingServices, setLoadingServices] = useState(true);

  const [saving, setSaving] = useState(false);

  /* Dummy services (replace later)
  const services = [
    { id: "gym", name: "Gym Access" },
    { id: "pt", name: "Personal Training" },
    { id: "yoga", name: "Yoga Class" },
  ];*/
  useEffect(() => {
  if (!business) {
    navigate("/business/login");
    return;
  }

  const fetchServices = async () => {
        try {
        const res = await fetch(`${API_URL.BUSINESS_SERVICES}`, {
            headers: {
              Authorization: `Bearer ${business.token}`,
              "x-session-id": business.sessionId,               
              "x-frontend-url": window.location.pathname  
            },
        });

        const data = await res.json();

        if (data.success) {
            setServices(data.services);
        }
        } catch (err) {
        console.error("Failed to load services", err);
        } finally {
        setLoadingServices(false);
        }
    };

    fetchServices();
    }, [business, navigate]);

  const handleContinue = async () => {
    if (!serviceId) return;

    if (saving) return;

    setSaving(true);

    try {
        const res = await fetch(
        `${API_URL.BUSINESS_WAIVER_SMART_STEP_SELECT_SERVICE}`,
        {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${business.token}`,
              "x-session-id": business.sessionId,               
              "x-frontend-url": window.location.pathname  
            },
            body: JSON.stringify({ serviceId }),
        }
        );

        const data = await res.json();

        if (data.success) {

          const updatedBusiness = {
            ...business,
            canEditBusinessType: false,
          };

          dispatch({
            type: "BUSINESS_LOGIN",
            payload: updatedBusiness,
          });

          navigate(`/business/waiverbuilder/smart/${data.waiverId}/step-2`);
        } else {
          alert(data.message); // show duplicate error
        }

    } catch (err) {
      console.error("Failed to save step 1", err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="h-screen flex bg-background">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 overflow-auto py-10">
        <div className="max-w-3xl mx-auto px-6">
          {/* Back */}
          <button
            onClick={() => navigate("/business/waiverbuilder/create")}
            className="text-sm text-muted-foreground mb-6 inline-flex items-center gap-1"
          >
            ← Back to creation mode
          </button>

          {/* Header */}
          <h1 className="text-2xl font-semibold mb-1">
            Eligibility Builder
          </h1>
          <p className="text-sm text-muted-foreground mb-8">
            Step 1 of 7 · Configure screening requirements
          </p>

          {/* Stepper */}
          <div className="flex items-center gap-6 mb-12 text-sm">
            <span className="font-medium">Service</span>
            <span className="text-muted-foreground">Minors</span>
            <span className="text-muted-foreground">Returning</span>
            <span className="text-muted-foreground">Questions</span>
          </div>

          {/* Card */}
          <div className="bg-white rounded-xl shadow-sm p-8">
            <h2 className="text-lg font-semibold mb-1">
              Select Your Service
            </h2>
            <p className="text-sm text-muted-foreground mb-6">
              Select the service this waiver will cover
            </p>

            {/* Service Dropdown */}
            <select
              value={serviceId}
              onChange={(e) => setServiceId(e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-4 py-3 mb-4"
            >
              <option value="">Select a service</option>
              {services.map((s) => (
                <option key={s._id} value={s._id}>
                  {s.name}
                </option>
              ))}
            </select>

            {/* Links */}
            <div className="space-y-3 text-sm mb-10">
              <div className="text-muted-foreground">
                Not seeing your services?{" "}
                <button
                  onClick={() => navigate("/business/edit-profile")}
                  className="underline font-medium text-black"
                >
                  Change business type
                </button>
              </div>

              <div className="text-muted-foreground">
                Service not listed?{" "}
                <button
                  onClick={() =>
                    navigate("/business/waiverbuilder/custom", {
                      state: { from: "smart-step1" },
                    })
                  }
                  className="underline font-medium text-black"
                >
                  Use a Custom Waiver
                </button>
              </div>
            </div>

            {/* Continue */}
            <div className="flex justify-end">
              <button
                disabled={!serviceId || saving}
                onClick={handleContinue}
                className={`px-6 py-3 rounded-full font-medium transition ${
                  !serviceId || saving
                    ? "bg-yellow-100 text-yellow-400 cursor-not-allowed"
                    : "bg-highlited text-black hover:bg-[#D5AA00]"
                }`}
              >
                {saving ? "Creating waiver... (Please wait)" : "Continue →"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessSmartTemplateStep1;